import { Pagination } from '../utils/types/pagination';
import { UpcomingServiceInterface } from '../utils/types/upcomingService';
import ApiService from './api';

export type CreateUpcomingServiceDto = Omit<
  UpcomingServiceInterface,
  'id' | 'state' | 'created_by' | 'updated_by' | 'createdAt' | 'updatedAt'
>;
export type UpdateUpcomingServiceDto = Omit<
  UpcomingServiceInterface,
  'id' | 'created_by' | 'updated_by' | 'createdAt' | 'updatedAt'
>;

export default class UpcomingServiceService extends ApiService {
  create = async (dto: CreateUpcomingServiceDto) => {
    const { data } = await this.axios.post('upcoming-service', dto);

    return data;
  };

  list = async (pagination: Pagination): Promise<UpcomingServiceInterface[]> => {
    const { data } = await this.axios.get('upcoming-services', {
      params: {
        attributes: pagination.attributes.join(','),
        page: pagination.page,
        perPage: pagination.perPage,
        join: pagination.join?.join(','),
        searchTerms: pagination.search,
        filterTerms: pagination.filter,
        order: pagination.order?.join(',')
      }
    });

    return data;
  };

  view = async (id: string) => {
    const { data } = await this.axios.get(`upcoming-service/${id}`);

    return data;
  };

  update = async (id: string, dto: UpdateUpcomingServiceDto) => {
    const { data } = await this.axios.put(`upcoming-service/${id}`, dto);

    return data;
  };

  delete = async (id: string) => {
    const { data } = await this.axios.delete(`upcoming-service/${id}`);

    return data;
  };
}
